import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { SYNC_CATEGORIES } from '../../lib/syncCategories.js';

/**
 * The 11 asset categories every sync copies, plus the personalization guarantee.
 * @returns {JSX.Element}
 */
export default function SyncChecklist() {
  return (
    <>
      <div className="space-y-3 pt-2" data-testid="sync-checklist">
        <div className="text-xs uppercase tracking-wider text-white/50 font-semibold">Operational Assets Included in Sync:</div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {SYNC_CATEGORIES.map(({ id, title, description, icon: Icon, tone }) => (
            <div key={id} className="p-3.5 rounded-xl border border-white/10 bg-black/30 flex items-start gap-3 hover:border-white/20 transition">
              <div className={`p-2 rounded-lg border shrink-0 mt-0.5 ${tone}`}><Icon className="w-4 h-4" /></div>
              <div className="space-y-0.5 min-w-0">
                <div className="text-sm font-semibold text-white flex items-start gap-1.5">
                  <span>{title}</span>
                  <Check className="w-3.5 h-3.5 text-emerald-400 shrink-0 mt-1" />
                </div>
                <div className="text-xs text-white/50 leading-relaxed">{description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="p-3.5 rounded-xl bg-civix-purple/10 border border-civix-purple/20 text-xs text-white/80 space-y-1 leading-relaxed">
        <div className="font-semibold text-civix-purpleSoft flex items-center gap-1.5">
          <Sparkles className="w-3.5 h-3.5" /> Dynamic Personalization Guarantee
        </div>
        <div>
          All cloned templates, bot scripts and drip messages automatically replace the source's personal details with your own via{' '}
          {['{{agent_name}}', '{{agent_phone}}', '{{booking_link}}', '{{digital_business_card}}'].map((t) => (
            <code key={t} className="text-civix-cyan font-mono text-[11px] mr-1">{t}</code>
          ))}
          When leads receive your texts, they see your verified info.
        </div>
      </div>
    </>
  );
}
